import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import NotFoundPage from 'pages/public/NotFoundPage';

import HotelShow from './HotelShow';
import HotelsList from './HotelsList';

const Hotels = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="list" replace />} />
      <Route path="list" element={<HotelsList />} />
      <Route path="show/:id" element={<HotelShow />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default Hotels;
